import { IDisplayDepartmentDTO } from 'src/api/dtos';
import http from 'src/api/http';
import ESSRepository from 'src/api/repositories/ess/ess.repository';
import { IListQueryResult } from 'src/api/types';

export default class DepartmentRepository extends ESSRepository {
  private static readonly baseRoute = '/departments';
  private static readonly apiURL = DepartmentRepository.setBaseUrl(this.baseURL, this.baseRoute);

  public get = async (): Promise<IDisplayDepartmentDTO[]> => {
    try {
      const { data } = await http.get<IListQueryResult<IDisplayDepartmentDTO>>(DepartmentRepository.apiURL);
      return data.items;
    } catch (e) {
      return Promise.reject(e);
    }
  };
}
